import { useSupabaseToken } from "./useSupabaseToken.mjs";
import { useState } from "#imports";
export const useSupabaseUser = () => {
  const user = useState("supabase_user");
  const token = useSupabaseToken();
  if (!token.value) {
    user.value = null;
  }
  return user;
};
